__webpack_require__.p = "/store/admin/digitalassets/";